export const upload = {
  image: {
    types: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
      'image/webp': ['.webp'],
    },
    maxFileSize: 20 * 1024 * 1024,
  },
};
